/** Garde pure : pas d’export âge TEC sans date « Au » renseignée. */
export function u3134CanExportTecAge(body: { asOfDate?: string | null }): boolean {
  return Boolean(body.asOfDate?.trim());
}
